"use client";

/**
 * The web app's Magnus SDK client.
 *
 * Web hosts the Magnus backend itself, so `baseUrl` is relative ("pointed
 * locally") and auth is the same-origin Better Auth session cookie. Inside
 * an Office add-in, WebView2 drops secure cookies, so we also attach the
 * add-in session token as a Bearer header (resolved per-request) — exactly
 * the behavior that previously lived inline in `trpc/react.tsx` and the
 * chat/tool hooks.
 */

import { type AuthStrategy, createMagnus } from "@bg-bgi/magnus-sdk";
import type { AppRouter } from "@workspace/api";
import { getEmbeddedSessionHeaders } from "@/lib/embedded-session";

const webAuth: AuthStrategy = {
  authenticate() {
    // Bearer header for whichever embedded copilot (Office add-in or Procore
    // panel) is active; `{}` on the standalone web surface.
    return {
      headers: getEmbeddedSessionHeaders(),
      credentials: "include",
    };
  },
};

export const magnusClient = createMagnus<AppRouter>({ auth: webAuth });
